import { render, staticRenderFns } from "./BudgetSidebar.vue?vue&type=template&id=58ddf77f&"
import script from "./BudgetSidebar.vue?vue&type=script&lang=js&"
export * from "./BudgetSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports